import { render, staticRenderFns } from "./CustomerHubActivity.vue?vue&type=template&id=7affb0f6&scoped=true"
import script from "./CustomerHubActivity.vue?vue&type=script&lang=js"
export * from "./CustomerHubActivity.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubActivity.vue?vue&type=style&index=0&id=7affb0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7affb0f6",
  null
  
)

export default component.exports